const development = {
  keycloak: {
    url: "https://authentication-staging.api.adit.periplus.ch/auth",
    realm: "commodity",
    clientId: "commodity",
    onLoad: "login-required",
    redirectUrl: "",
  },
  hasura: "https://staging.cp.api.adit.periplus.ch/v1/graphql",
  blobStorage: {
    documentsContainerName:
      process.env.REACT_APP_CI_COMMIT_REF_SLUG || "documents",
    thumbsContainerName: "thumbs-" + process.env.REACT_APP_CI_COMMIT_REF_SLUG,
    storageAccountName: "aditdocuments",
    commodity: "commodity",
  },
  maxFileSize: process.env.REACT_APP_MAX_FILE_SIZE || 100,
};

const test = {
  keycloak: {
    url: "https://authentication-staging.api.adit.periplus.ch/auth",
    realm: "commodity",
    clientId: "commodity",
    onLoad: "login-required",
    redirectUrl: "",
  },
  hasura: "http://localhost:8080/v1/graphql",
  blobStorage: {
    documentsContainerName: "documents",
    thumbsContainerName: "thumbs",
    storageAccountName: "aditdocuments",
    commodity: "commodity",
  },
  maxFileSize: process.env.REACT_APP_MAX_FILE_SIZE || 100,
};

const staging = {
  keycloak: {
    url: "https://authentication-staging.api.adit.periplus.ch/auth",
    realm: "commodity",
    clientId: "commodity",
    onLoad: "login-required",
    redirectUrl: "",
  },
  hasura: "https://staging.cp.api.adit.periplus.ch/v1/graphql",
  blobStorage: {
    documentsContainerName: "documents",
    thumbsContainerName: "thumbs",
    storageAccountName: "aditdocuments",
    commodity: "commodity",
  },
  maxFileSize: process.env.REACT_APP_MAX_FILE_SIZE || 100,
};

const production = {
  keycloak: {
    url: "https://authentication.api.adit.periplus.ch/auth",
    realm: "commodity",
    clientId: "commodity",
    onLoad: "login-required",
    redirectUrl: "https://adit.periplus.ch/login",
  },
  hasura: "https://production.api.adit.periplus.ch/v1/graphql",
  blobStorage: {
    documentsContainerName: "documents",
    thumbsContainerName: "thumbs",
    storageAccountName: "aditdocumentsproduction",
    commodity: "commodity",
  },
  maxFileSize: process.env.REACT_APP_MAX_FILE_SIZE || 100,
};

// Default to development if not set
function getConfig() {
  switch (process.env.REACT_APP_ENVIRONMENT) {
    case "development":
      return development;
    case "test":
      return test;
    case "staging":
      return staging;
    case "production":
      return production;
    default:
      return development;
  }
}

const isProdMode = process.env.REACT_APP_ENVIRONMENT === "production";

// Default to development if not set
const config = getConfig();

export default {
  // All "common", general config or initial values belong here...
  START_MESSAGE: "Hello World",
  graphQl: {
    url: config.hasura || "http://localhost:5000",
  },
  isProdMode,
  ...config,
};
